import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDividerDotted20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconDividerDotted20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.656 2.425c-.69 0-1.25.56-1.25 1.25v1.95a.75.75 0 1 1-1.5 0v-1.95a2.75 2.75 0 0 1 2.75-2.75h8.688a2.75 2.75 0 0 1 2.75 2.75v1.95a.75.75 0 0 1-1.5 0v-1.95c0-.69-.56-1.25-1.25-1.25zm0 15.15c-.69 0-1.25-.56-1.25-1.25v-1.95a.75.75 0 0 0-1.5 0v1.95a2.75 2.75 0 0 0 2.75 2.75h8.688a2.75 2.75 0 0 0 2.75-2.75v-1.95a.75.75 0 0 0-1.5 0v1.95c0 .69-.56 1.25-1.25 1.25zM3.75 10.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M7.5 10A.75.75 0 1 1 6 10a.75.75 0 0 1 1.5 0m2.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M13.5 10a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDividerDotted20);
